module.exports = __webpack_public_path__ + "img/card_icon_5.08cc2740.svg";